import { render, staticRenderFns } from "./Layout-3.vue?vue&type=template&id=4b7f447e&"
import script from "./Layout-3.vue?vue&type=script&lang=ts&"
export * from "./Layout-3.vue?vue&type=script&lang=ts&"
import style0 from "./Layout-3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports